import React from 'react';
import { Link } from 'react-router-dom';
import BoostIcon from '../../../assets/icons/landing/purpleBoost.svg';
import { usePreviewMode } from '../../../helpers/hooks/useCheckPreviewMode';

export const BoostBanner = () => {
  const { previewUserAddress } = usePreviewMode();
  const weeklyRewardTo = previewUserAddress
    ? `/weeklyReward?previewUser=${previewUserAddress}`
    : '/weeklyReward';

  return (
    <Link to={weeklyRewardTo} className="flex lg:px-[1.6rem] w-full custom-transition hover:opacity-90">
      <div className="overflow-hidden relative flex w-full bg-[linear-gradient(269deg,#985AFF_0.17%,#0C0C0E_49.91%)] rounded-[3rem] h-[10rem] lg:h-[9.6rem] lg:rounded-[2rem] lg:bg-[linear-gradient(90deg,#985AFF_0%,#0C0C0E_100%)]">
        <div className="flex items-center justify-between h-full w-full rounded-[3rem] items-center w-full p-[1rem] border-[0.1rem] border-dashed border-[rgba(255,255,255,0.10)] z-[1] lg:flex-col lg:items-start lg:justify-center lg:space-y-[1.6rem] lg:px-[2rem]">
          <div className="flex items-center space-x-[2.6rem] lg:space-x-0 ">
            <div className="flex items-center justify-center w-[8rem] h-[8rem] bg-[linear-gradient(135deg,#242426_0%,#101012_100%)] rounded-[2rem] lg:hidden">
              <img className="w-[4.4rem] h-[4.4rem]" src={BoostIcon} />
            </div>
            <div className="flex flex-col sapce-y-[1.2rem] lg:space-y-[0.4rem]">
              <span className="text-[2.4rem] text-white leading-normal tracking-[-0.48px] font-500 lg:text-[1.6rem] lg:tracking-[-0.32px]">
                Boost levels
              </span>
              <span className="text-[1.4rem] text-white-500 tracking-[-0.14px] leading-normal lg:text-[1.2rem] lg:tracking-[-0.12px]">
                Get more income with weekly reward
              </span>
            </div>
          </div>
        </div>
        <img
          src="/images/dashboard/boostBanner/pic.webp"
          className="absolute pointer-events-none left-1/2 -translate-x-1/2 ml-[7rem] z-[0] lg:hidden"
        />
        <img
          src="/images/dashboard/boostBanner/picMob.webp"
          className="absolute pointer-events-none  right-0 z-[0] hidden lg:flex"
        />
      </div>
    </Link>
  );
};
